import { render, staticRenderFns } from "./Suspension.vue?vue&type=template&id=d89379a4&scoped=true&"
import script from "./Suspension.vue?vue&type=script&lang=js&"
export * from "./Suspension.vue?vue&type=script&lang=js&"
import style0 from "./Suspension.vue?vue&type=style&index=0&id=d89379a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89379a4",
  null
  
)

export default component.exports